import countries from "../_data/countries.json";

const countriesReverse = {};
for (const key in countries) {
	countriesReverse[countries[key]] = key;
}

class FlagHelper {

}

FlagHelper.getAllFlagCodes = () => {
	return Object.keys(countries);
};
FlagHelper.isValidFlag = (cc) => {
	// Valid ISO 3166-1 alpha-2 codes
	// Likely a country name or will be unknown.
	if (typeof countries[cc] === "string" || typeof countriesReverse[cc] === "string") {
		return true;
	}
	return false;
};
FlagHelper.toFlagCountryCode = (cc) => {
	// Valid ISO 3166-1 alpha-2 codes
	if (typeof countries[cc] === "string") {
		return cc.toLowerCase();
	}
	// Likely a country name or will be unknown.
	else if (typeof countriesReverse[cc] === "string") {
		return countriesReverse[cc].toLowerCase();
	}
	return "";
};
FlagHelper.toFlagCountryName = (cc) => {
	// Valid ISO 3166-1 alpha-2 codes
	if (typeof countries[cc] === "string") {
		return countries[cc];
	}
	// Likely a country name or will be unknown.
	else if (typeof countriesReverse[cc] === "string") {
		return cc;
	}
	return "";
};

export default FlagHelper;
